<template lang="pug">
  .footprint-card
    tilt-card(:img="img" :copy="copy" @clicked="onClick")
</template>
<script>
import TiltCard from "@/components/home/TiltCard2"
import { mapGetters, mapMutations, mapState, mapActions } from "vuex"
import PopupSingle from "@/components/wedgits/PopupSingle"
const footprintductionImg = require("src/assets/footprint.png")
export default {
  name: "footprintCard",
  components: { TiltCard, PopupSingle },
  props: {},
  data() {
    return {
      img: footprintductionImg,
      copy: {
        cn: "惊喜盲盒 & 我的足迹",
        en: "Mystery Box & Footprint"
      },
      notask: false
    }
  },
  watch: {
    appStatus() {
      this.$nextTick(() => {
        mySwiper && mySwiper.update()
        mySwiper && mySwiper.slideTo(0)
      })
    },
    user() {
      this.fetchFootprintTaskListAll()
    }
  },
  computed: {
    ...mapState("app", ["user", "appStatus", "ageWarning", "ageWarningShowed"])
  },
  methods: {
    ...mapMutations("app", [
      "setRouterBack",
      "setPending",
      "ageWarningConfirm",
      "resetWarning",
      "showAgeWarning"
    ]),
    ...mapActions("app", ["GetFootprintTaskListAll"]),
    fetchFootprintTaskListAll() {
      this.setPending(true)
      this.GetFootprintTaskListAll({ userId: this.user.id })
        .then(data => {
          if (!data.branchTask.length && !data.masterTask.length) {
            this.notask = true
          }

          this.setPending(false)
        })
        .catch(err => {
          console.log(err)
          this.setPending(false)
        })
    },
    onClick() {
      if(this.appStatus==2){
        this.$router.replace("/footprint/welcome")
        this.setRouterBack("/")
      }
      if(this.notask && this.appStatus != 2){
        this.resetWarning()
        this.showAgeWarning()
        return
      }
      if(!this.notask && this.appStatus != 2){
        this.$router.replace("/footprint/sticker")
        this.setRouterBack("/")
      }
    }
  }
}
</script>

<style>
.footprintHtml {
  font-size: calc(100vw / 8.28) !important;
}
</style>

<style scoped lang="sass">
.footprint-card
  width: 100%
  height: 100%
</style>
